// extracted by mini-css-extract-plugin
export default {"employee-container":"MidMonthPay_employee-container__upNxR","mid-month-header":"MidMonthPay_mid-month-header__5qtSC"};